export default __webpack_public_path__ + "static/media/m2.7241c10b.png";